import React, { useState, useEffect } from "react";
import "../forms/as7dk9f3n5v2x/styles/variables.css";
import "../forms/as7dk9f3n5v2x/styles/form.css";
import "../forms/as7dk9f3n5v2x/styles/components.css";
import "../forms/as7dk9f3n5v2x/styles/typography.css";
import MenuBar from "../forms/as7dk9f3n5v2x/components/common/MenuBar";
import { useNavigate } from "react-router-dom";
import PageNavigation from "../forms/as7dk9f3n5v2x/components/layout/PageNavigation";
// 필드 컴포넌트 불러오기
import {
  DynamicField,
  ConditionalField,
  ConditionalSection,
  SingleColumnLayout,
  TwoColumnLayout,
  DateWithAgeField,
} from "../fields/fields";

// ProcessBar 컴포넌트를 직접 구현합니다. (템플릿에서 가져온 페이지 정보를 기반으로 함)
const ProcessBar = ({ currentPage, totalPages, onPageClick, pagesData }) => {
  // 페이지 이름 가져오기
  const getPageName = (pageNumber) => {
    // 페이지 데이터가 있는 경우 해당 페이지 제목 반환
    if (pagesData && pagesData.length > 0) {
      const pageData = pagesData.find(
        (page) => page.page_number === pageNumber
      );
      if (pageData && pageData.page_title) {
        return pageData.page_title;
      }
    }

    // 페이지 데이터가 없는 경우 기본값 사용
    switch (pageNumber) {
      case 1:
        return "기본 정보";
      case 2:
        return "응급 처치 정보";
      case 3:
        return "임상 결과";
      default:
        return `페이지 ${pageNumber}`;
    }
  };

  return <div className="process-bar"></div>;
};

const NewCase = ({ projectId: propProjectId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(3); // 기본값은 3, 나중에 템플릿 데이터로 업데이트
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [templateData, setTemplateData] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);
  const [projectId, setProjectId] = useState(propProjectId); // prop으로 받은 projectId 설정
  const [formError, setFormError] = useState(false); // 폼 로드 오류 상태 추가
  const [apiMessage, setApiMessage] = useState(""); // API 응답 메시지를 저장할 상태 추가

  // 디버깅: projectId 변경 감지
  useEffect(() => {
    console.log("NewCase - ProjectId prop:", propProjectId);
    console.log("NewCase - ProjectId state:", projectId);

    if (propProjectId && propProjectId !== projectId) {
      console.log("NewCase - ProjectId 상태 업데이트:", propProjectId);
      setProjectId(propProjectId);
    }

    // 세션 스토리지에서도 프로젝트 ID 확인
    const storedProject = sessionStorage.getItem("currentProject");
    if (storedProject) {
      try {
        const parsedProject = JSON.parse(storedProject);
        console.log("세션 스토리지의 프로젝트 데이터:", parsedProject);

        if (parsedProject.id && !projectId) {
          console.log("세션 스토리지에서 ProjectId 가져옴:", parsedProject.id);
          setProjectId(parsedProject.id);
        }
      } catch (error) {
        console.error("세션 스토리지 프로젝트 데이터 파싱 오류:", error);
      }
    } else {
      console.log("세션 스토리지에 프로젝트 데이터 없음");
    }
  }, [propProjectId, projectId]);

  // 개발 모드에서 사용할 더미 데이터 (테스트용)
  const useDummyData = () => {
    // API 연결 오류 시 사용할 더미 데이터
    console.log("더미 데이터 사용 중...");
    try {
      // 로컬 스토리지에서 먼저 확인
      const stored = localStorage.getItem("ecrf_form_structure");
      if (stored) {
        console.log("localStorage에서 폼 데이터 로드");
        return JSON.parse(stored);
      }

      // 기본 더미 데이터
      return {
        form_name: "테스트 폼",
        pages: [
          {
            page_number: 1,
            page_title: "기본 정보",
            sections: [
              {
                section_id: "section1",
                section_title: "환자 정보",
                fields: [
                  {
                    field_id: "pt_name",
                    label: "환자 이름",
                    type: "text",
                    layout: "half",
                  },
                  {
                    field_id: "pt_number",
                    label: "환자 번호",
                    type: "text",
                    layout: "half",
                  },
                ],
              },
            ],
          },
        ],
      };
    } catch (error) {
      console.error("더미 데이터 로드 오류:", error);
      return {
        form_name: "오류 복구 폼",
        pages: [
          {
            page_number: 1,
            page_title: "기본 페이지",
            sections: [
              {
                section_id: "error_section",
                section_title: "오류 발생",
                fields: [],
              },
            ],
          },
        ],
      };
    }
  };

  // formData state 정의
  const [formData, setFormData] = useState({
    // 기본 정보 섹션
    pt_name: "", // 환자 이름
    pt_number: "", // 환자 번호
    birth: "", // 생년월일
    sex: "", // 성별
    height: "", // 키
    weight: "", // 몸무게

    // 병원 전 단계 섹션
    arrest_location: "", // 심정지 발생장소
    arrest_location_others: "", // 기타 장소 상세내용
    witness: "", // 심정지 목격
    witness_by: "", // 심정지 발견 목격자/발견자

    // 구급대원 심폐소생술 섹션
    EMS_call_time: "", // EMS 신고 시각
    EMS_arrive_time: "", // EMS 현장 도착 시각
    EMS_CPR: "", // 구급대원 흉부압박
    EMS_1st_rhythm: "", // 첫 리듬
    EMS_shock: "", // 구급대원 제세동

    // 환자 도착 정보 섹션
    ED_arrival_time: "", // 응급실 도착 시각
    Transport: "", // 병원 이송 수단
    transfer: "", // 타 병원에서 전원 옴
    transfer_hospital: "", // 전원 보낸 병원명

    // 응급실 심폐소생술 결과 섹션
    ROSC: "", // 자발순환회복 여부
    ED_ROSC_datetime: "", // 자발순환회복 시각
    Cause_arrest: "", // 심정지 원인
    ED_disposition: "", // 결과

    // CPC 관련 필드
    Baseline_CPC: "", // 심정지 발생 전 CPC
    Discharge_CPC: "", // 퇴원시 CPC

    // 특이사항
    note: "", // 특이사항
  });

  // 폼 템플릿 데이터 가져오기
  useEffect(() => {
    const fetchTemplateData = async () => {
      console.log("=== fetchTemplateData 호출 시작 ===");
      console.log("projectId:", projectId);

      try {
        setInitialLoading(true);
        setFormError(false); // 오류 상태 초기화
        setApiMessage(""); // API 메시지 초기화

        // 개발 모드 감지 (process.env.NODE_ENV === 'development')
        const isDevelopment = process.env.NODE_ENV === "development";
        // 로컬 개발 모드에서 API 우회 옵션 (필요에 따라 주석 해제)
        const bypassAPI = false; // 테스트 중 서버 없이 작업할 때는 true로 설정

        if (bypassAPI && isDevelopment) {
          console.log("개발 모드: API 호출을 우회하고 더미 데이터 사용");
          const dummyData = useDummyData();
          setTemplateData(dummyData);
          setTotalPages(dummyData.pages.length);
          initializeFormData(dummyData);
          setApiMessage("개발 모드: 더미 데이터를 사용 중입니다.");
          setInitialLoading(false);
          return;
        }

        if (projectId) {
          console.log("프로젝트 ID가 있어 API 호출 시도:", projectId);

          try {
            // API 엔드포인트 설정
            const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "/api";

            // API를 통해 폼 구조 데이터 가져오기
            console.log(`API 호출: ${API_ENDPOINT}/get-form 실행`);

            // 헤더에 인증 토큰 추가
            let token = localStorage.getItem("token");
            if (!token) {
              token = sessionStorage.getItem("token");
              if (!token) {
                console.warn("인증 토큰을 찾을 수 없습니다.");
                setApiMessage(
                  "인증 토큰이 없습니다. 로그인이 필요할 수 있습니다."
                );
              }
            }

            const headers = {
              "Content-Type": "application/json",
            };

            if (token) {
              headers["Authorization"] = `Bearer ${token}`;
            }

            // 타임아웃 설정으로 fetch 강화
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 10000); // 10초 타임아웃

            try {
              // API 요청
              const apiResponse = await fetch(
                `${API_ENDPOINT}/get-form?project_id=${projectId}`,
                {
                  method: "GET",
                  headers,
                  signal: controller.signal,
                }
              );

              clearTimeout(timeoutId); // 타임아웃 취소

              // 응답 JSON 파싱
              const response = await apiResponse.json();
              console.log("API 응답 데이터:", response);

              // API 응답 메시지 저장
              if (response && response.message) {
                console.log("API 응답 메시지:", response.message);
                setApiMessage(response.message);
              }

              if (response && response.success) {
                console.log("API 호출 성공, 데이터 존재");

                if (response.data && response.data.form_structure) {
                  console.log(
                    "폼 구조 데이터 존재:",
                    typeof response.data.form_structure
                  );

                  // JSON 필드 처리 (이미 파싱되었거나 문자열일 수 있음)
                  const data =
                    typeof response.data.form_structure === "string"
                      ? JSON.parse(response.data.form_structure)
                      : response.data.form_structure;

                  console.log("파싱된 폼 구조 데이터:", data);
                  setTemplateData(data);

                  if (data.pages && data.pages.length > 0) {
                    console.log("페이지 수:", data.pages.length);
                    setTotalPages(data.pages.length);
                  } else {
                    console.warn("폼 구조에 페이지 데이터가 없거나 비어있음");
                  }

                  initializeFormData(data);
                  console.log("폼 데이터 초기화 완료");
                  return; // 성공적으로 로드되면 여기서 종료
                } else {
                  console.error(
                    "API 응답에 form_structure 필드가 없음:",
                    response
                  );
                  setApiMessage("API 응답에 form_structure 필드가 없습니다.");
                  throw new Error("API 응답에 form_structure 필드가 없습니다.");
                }
              } else {
                console.error("API 응답이 성공 상태가 아님:", response);
                setApiMessage(
                  response.message || "API 응답이 성공 상태가 아닙니다."
                );
                throw new Error("API 응답이 성공 상태가 아닙니다.");
              }
            } catch (fetchError) {
              if (fetchError.name === "AbortError") {
                console.error("API 호출 타임아웃:", fetchError);
                setApiMessage(
                  "서버 연결 시간이 초과되었습니다. 네트워크 상태를 확인해주세요."
                );
              } else {
                console.error("API fetch 오류:", fetchError);
                setApiMessage(
                  fetchError.message || "서버에 연결할 수 없습니다."
                );
              }
              throw fetchError;
            }
          } catch (apiError) {
            console.error("API 호출 중 오류 발생:", apiError);
            // 사용자에게 더 유용한 메시지 제공
            let userMessage = "서버 연결에 실패했습니다.";

            if (apiError.message === "Failed to fetch") {
              userMessage =
                "서버에 연결할 수 없습니다. 서버가 실행 중인지 확인하거나 네트워크 연결을 확인해주세요.";
            } else if (apiError.message.includes("NetworkError")) {
              userMessage =
                "네트워크 오류가 발생했습니다. 인터넷 연결을 확인해주세요.";
            } else if (apiError.message.includes("CORS")) {
              userMessage =
                "브라우저 보안 정책(CORS) 문제가 발생했습니다. 관리자에게 문의하세요.";
            }

            setApiMessage(userMessage);
            console.log("localStorage에서 폼 데이터 시도 예정");
            throw apiError; // 다음 단계로 오류 전파
          }
        } else {
          console.log("프로젝트 ID가 없어 API 호출 생략");
          setApiMessage("프로젝트 ID가 없어 API 호출을 생략했습니다.");
        }

        // projectId가 없거나 API 응답에 폼 구조가 없는 경우
        // localStorage에서 시도
        console.log("localStorage에서 'ecrf_form_structure' 확인");
        const stored = localStorage.getItem("ecrf_form_structure");

        if (stored) {
          console.log("localStorage에서 데이터 찾음");
          try {
            const data = JSON.parse(stored);
            console.log("localStorage에서 파싱된 데이터:", data);

            setTemplateData(data);
            if (data.pages && data.pages.length > 0) {
              console.log("localStorage 데이터 페이지 수:", data.pages.length);
              setTotalPages(data.pages.length);
            }

            initializeFormData(data);
            console.log("localStorage 데이터로 폼 초기화 완료");
            setApiMessage(
              "서버 연결에 실패했습니다. 로컬에 저장된 폼 데이터를 사용합니다."
            );
          } catch (parseError) {
            console.error("localStorage 데이터 파싱 오류:", parseError);
            setApiMessage("폼 구조 데이터 파싱에 실패했습니다.");
            throw new Error("폼 구조 데이터 파싱에 실패했습니다.");
          }
        } else {
          console.error("localStorage에 'ecrf_form_structure' 없음");
          setApiMessage(
            "폼 구조 데이터를 찾을 수 없습니다. 서버가 실행 중인지 확인하세요."
          );
          throw new Error("폼 구조 데이터를 찾을 수 없습니다.");
        }
      } catch (error) {
        console.error("템플릿 데이터 로딩 오류:", error);
        // 더미 데이터 대신 오류 상태 설정
        setFormError(true);
        if (!apiMessage) {
          setApiMessage(
            error.message || "템플릿 데이터 로딩 중 오류가 발생했습니다."
          );
        }
      } finally {
        setInitialLoading(false);
        console.log("=== fetchTemplateData 완료 ===");
      }
    };

    fetchTemplateData();
  }, [projectId]);

  // 폼 데이터 초기화 함수
  const initializeFormData = (template) => {
    if (!template || !template.pages) return;

    const initialData = {};

    // 템플릿의 모든 페이지와 섹션을 순회하며 초기 데이터 구조 생성
    template.pages.forEach((page) => {
      if (page.sections) {
        page.sections.forEach((section) => {
          if (section.fields) {
            section.fields.forEach((field) => {
              initialData[field.field_id] = "";
            });
          }
        });
      }
    });

    setFormData(initialData);
  };

  // 계산 필드 값 추적을 위한 변수
  const calculatedFieldsRef = React.useRef([]);
  const dependencyFieldsRef = React.useRef({});

  // 계산 필드와 의존성 필드 찾기
  useEffect(() => {
    if (!templateData || !templateData.pages) return;

    const calcFields = [];
    const depFields = {};

    // 모든 계산 필드와 의존성 찾기
    templateData.pages.forEach((page) => {
      if (page.sections) {
        page.sections.forEach((section) => {
          if (section.fields) {
            section.fields.forEach((field) => {
              if (field.type === "calculated" && field.formula) {
                calcFields.push(field);

                // 의존성 필드 추적
                if (Array.isArray(field.dependsOn)) {
                  field.dependsOn.forEach((depFieldId) => {
                    depFields[depFieldId] = true;
                  });
                } else if (field.dependsOn) {
                  depFields[field.dependsOn] = true;
                }
              }
            });
          }
        });
      }
    });

    calculatedFieldsRef.current = calcFields;
    dependencyFieldsRef.current = depFields;

    // 첫 로드 시 계산 필드 업데이트
    updateCalculatedFields();
  }, [templateData]);

  // 의존성 필드 변경 감지 및 계산 필드 업데이트
  useEffect(() => {
    if (Object.keys(dependencyFieldsRef.current).length === 0) return;

    // 의존성 필드에 변경이 있는지 확인
    const hasDependencyChange = Object.keys(dependencyFieldsRef.current).some(
      (fieldId) => formData[fieldId] !== undefined
    );

    if (hasDependencyChange) {
      updateCalculatedFields();
    }
  }, [formData]);

  // 계산 필드 업데이트 함수
  const updateCalculatedFields = () => {
    if (calculatedFieldsRef.current.length === 0) return;

    const newFormData = { ...formData };
    let hasChanges = false;

    calculatedFieldsRef.current.forEach((field) => {
      if (field.formula) {
        const calculatedValue = field.formula(formData);
        if (newFormData[field.field_id] !== calculatedValue) {
          newFormData[field.field_id] = calculatedValue;
          hasChanges = true;
        }
      }
    });

    if (hasChanges) {
      setFormData(newFormData);
    }
  };

  // 필드 값 변경 핸들러
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // 페이지 이동 처리
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // 폼 제출 처리
  const handleSubmit = async () => {
    try {
      setLoading(true);

      console.log("제출할 데이터:", formData);

      // API 엔드포인트 설정
      const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "/api";

      // 실제 API 호출
      const response = await fetch(`${API_ENDPOINT}/forms`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          template_id: templateData?.template_id,
          group_id: templateData?.group_id,
          formData: formData,
        }),
      });

      if (!response.ok) {
        throw new Error("데이터 저장에 실패했습니다");
      }

      const result = await response.json();

      // 제출 성공 시 처리
      alert("데이터가 성공적으로 제출되었습니다!");
      navigate("/ecrf/subjectlist");
    } catch (error) {
      console.error("데이터 제출 오류:", error);
      alert("데이터 제출 중 오류가 발생했습니다: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // 현재 페이지 콘텐츠 렌더링
  const renderPageContent = () => {
    if (initialLoading) {
      return (
        <div className="loading-page">
          <div className="loading-spinner"></div>
        </div>
      );
    }

    if (formError) {
      return (
        <div
          className="error-page"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "70vh",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div
            className="error-icon"
            style={{
              fontSize: "64px",
              color: "#f44336",
              marginBottom: "20px",
            }}
          >
            ⚠️
          </div>
          <h3
            style={{
              fontSize: "24px",
              color: "#f44336",
              marginBottom: "10px",
            }}
          >
            Form 정보를 불러오는 것에 실패했습니다!
          </h3>
          <p
            style={{
              fontSize: "16px",
              color: "#666",
              maxWidth: "500px",
              marginBottom: "10px",
            }}
          >
            서버 연결을 확인하거나 관리자에게 문의하세요.
          </p>
          {apiMessage && (
            <div
              className="api-message"
              style={{
                fontSize: "14px",
                color: "#d32f2f",
                backgroundColor: "#ffebee",
                padding: "10px",
                borderRadius: "4px",
                maxWidth: "500px",
              }}
            >
              <strong>서버 메시지:</strong> {apiMessage}
            </div>
          )}
        </div>
      );
    }

    if (!templateData || !templateData.pages) {
      return (
        <div
          className="error-page"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "70vh",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div
            className="error-icon"
            style={{
              fontSize: "64px",
              color: "#f44336",
              marginBottom: "20px",
            }}
          >
            ⚠️
          </div>
          <h3
            style={{
              fontSize: "24px",
              color: "#f44336",
              marginBottom: "10px",
            }}
          >
            Form 정보를 불러오는 것에 실패했습니다!
          </h3>
          <p
            style={{
              fontSize: "16px",
              color: "#666",
              maxWidth: "500px",
              marginBottom: "10px",
            }}
          >
            폼 구조가 올바르지 않습니다.
          </p>
          {apiMessage && (
            <div
              className="api-message"
              style={{
                fontSize: "14px",
                color: "#d32f2f",
                backgroundColor: "#ffebee",
                padding: "10px",
                borderRadius: "4px",
                maxWidth: "500px",
              }}
            >
              <strong>서버 메시지:</strong> {apiMessage}
            </div>
          )}
        </div>
      );
    }

    // 현재 페이지 데이터 찾기
    const currentPageData = templateData.pages.find(
      (page) => page.page_number === currentPage
    );
    if (!currentPageData) return null;

    return (
      <div className="page-content">
        {currentPageData.sections &&
          currentPageData.sections.map((section) => {
            // 조건부 섹션 처리
            if (section.dependsOn) {
              return (
                <ConditionalSection
                  key={section.section_id}
                  section={section}
                  formData={formData}
                  handleChange={handleChange}
                  dependsOn={section.dependsOn}
                  dependsOnValue={section.dependsOnValue}
                />
              );
            }

            // 일반 섹션 처리
            return (
              <div key={section.section_id} className="form-section">
                <h3>{section.section_title}</h3>

                {section.fields &&
                  renderFields(section.fields, formData, handleChange)}
              </div>
            );
          })}
      </div>
    );
  };

  // 필드 렌더링 유틸리티 함수
  const renderFields = (fields, formData, handleChange) => {
    let renderedFields = [];
    let currentRow = [];

    fields.forEach((field, index) => {
      // 계산 필드는 별도 표시 로직만 처리하고 값 업데이트는 useEffect에서 처리
      if (field.type === "calculated") {
        // 렌더링만 처리하고 handleChange 호출 제거
      }

      // 조건부 필드 처리
      if (field.dependsOn) {
        const shouldShow = checkCondition(
          field.dependsOn,
          field.dependsOnValue,
          formData
        );
        if (!shouldShow) return;
      }

      // 레이아웃 결정
      const fieldComponent = getFieldComponent(field, formData, handleChange);

      if (field.layout === "full") {
        // 이전 행이 있다면 먼저 렌더링
        if (currentRow.length > 0) {
          renderedFields.push(
            <TwoColumnLayout
              key={`row-${renderedFields.length}`}
              leftChild={currentRow[0].component}
              leftTitle={currentRow[0].title}
              rightChild={
                currentRow.length > 1 ? currentRow[1].component : null
              }
              rightTitle={currentRow.length > 1 ? currentRow[1].title : null}
            />
          );
          currentRow = [];
        }

        // 전체 너비 필드 추가
        renderedFields.push(
          <SingleColumnLayout key={field.field_id} title={field.label}>
            {fieldComponent}
          </SingleColumnLayout>
        );
      } else {
        // 2컬럼 레이아웃용 필드 처리
        currentRow.push({
          component: fieldComponent,
          title: field.label,
        });

        // 행이 완성되었거나 마지막 필드인 경우
        if (currentRow.length === 2 || index === fields.length - 1) {
          renderedFields.push(
            <TwoColumnLayout
              key={`row-${renderedFields.length}`}
              leftChild={currentRow[0].component}
              leftTitle={currentRow[0].title}
              rightChild={
                currentRow.length > 1 ? currentRow[1].component : null
              }
              rightTitle={currentRow.length > 1 ? currentRow[1].title : null}
            />
          );
          currentRow = [];
        }
      }
    });

    return renderedFields;
  };

  // 조건 체크 유틸리티 함수
  const checkCondition = (dependsOn, dependsOnValue, formData) => {
    // 의존하는 필드가 없으면 항상 표시
    if (!dependsOn) return true;

    // 여러 필드에 의존하는 경우
    if (Array.isArray(dependsOn)) {
      // 모든 의존 필드에 값이 있어야 조건 검사 가능
      const allDependenciesHaveValues = dependsOn.every(
        (field) => formData[field] !== undefined && formData[field] !== ""
      );
      if (!allDependenciesHaveValues) return false;

      return true; // 구체적인 로직은 필요에 따라 구현
    }

    const dependencyValue = formData[dependsOn];

    // 다양한 조건 유형 처리
    if (typeof dependsOnValue === "function") {
      return dependsOnValue(dependencyValue);
    }

    // 배열인 경우 - 여러 값 중 하나라도 일치하면 표시
    if (Array.isArray(dependsOnValue)) {
      return dependsOnValue.includes(dependencyValue);
    }

    // 단일 값 - 정확히 일치할 때 표시
    return dependencyValue === dependsOnValue;
  };

  // 필드 컴포넌트 반환 함수
  const getFieldComponent = (field, formData, handleChange) => {
    // 계산 필드 처리
    if (field.type === "calculated") {
      // 계산 필드는 읽기 전용으로 표시만 함
      return (
        <div className="calculated-field">
          <span className="calculated-value">
            {formData[field.field_id] || ""}
          </span>
        </div>
      );
    }

    // 필드 타입에 따라 적절한 컴포넌트 반환
    if (field.type === "date" && field.showAge) {
      return (
        <DateWithAgeField
          field={field}
          value={formData[field.field_id]}
          onChange={handleChange}
        />
      );
    }

    // 조건부 필드인 경우
    if (field.dependsOn) {
      return (
        <ConditionalField
          field={field}
          value={formData[field.field_id]}
          dependsOn={field.dependsOn}
          dependsOnValue={field.dependsOnValue}
          onChange={handleChange}
          formData={formData}
        />
      );
    }

    // 기본 동적 필드 컴포넌트 반환
    return (
      <DynamicField
        field={field}
        value={formData[field.field_id]}
        onChange={handleChange}
        formData={formData}
      />
    );
  };

  if (initialLoading) {
    return (
      <div className="ohca-form-container">
        <MenuBar />
        <div
          className="loading-page"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "70vh",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div className="loading-spinner"></div>
          <p>폼 템플릿을 로딩 중입니다...</p>
        </div>
      </div>
    );
  }

  // 폼 구조 로드 실패 시 오류 메시지만 표시
  if (formError || !templateData || !templateData.pages) {
    return (
      <div className="ohca-form-container">
        <MenuBar />
        <div
          className="error-page"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "70vh",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div
            className="error-icon"
            style={{
              fontSize: "64px",
              color: "#f44336",
              marginBottom: "20px",
            }}
          >
            ⚠️
          </div>
          <h3
            style={{
              fontSize: "24px",
              color: "#f44336",
              marginBottom: "10px",
            }}
          >
            Form 정보를 불러오는 것에 실패했습니다!
          </h3>
          <p
            style={{
              fontSize: "16px",
              color: "#666",
              maxWidth: "500px",
              marginBottom: "10px",
            }}
          >
            서버 연결을 확인하거나 관리자에게 문의하세요.
          </p>
          {apiMessage && (
            <div
              className="api-message"
              style={{
                fontSize: "14px",
                color: "#d32f2f",
                backgroundColor: "#ffebee",
                padding: "10px",
                borderRadius: "4px",
                maxWidth: "500px",
              }}
            >
              <strong>서버 메시지:</strong> {apiMessage}
            </div>
          )}
        </div>
      </div>
    );
  }

  // 폼 구조 로드 성공 시 전체 UI 표시
  return (
    <div className="ohca-form-container">
      <MenuBar />
      <h1 className="form-title">
        {templateData?.form_name || "새 증례 등록"}
      </h1>

      {apiMessage && (
        <div
          className="api-message-success"
          style={{
            fontSize: "14px",
            color: "#388e3c",
            backgroundColor: "#e8f5e9",
            padding: "8px 16px",
            borderRadius: "4px",
            margin: "0 auto 16px auto",
            maxWidth: "80%",
            textAlign: "center",
          }}
        >
          <strong>알림:</strong> {apiMessage}
        </div>
      )}

      <ProcessBar
        currentPage={currentPage}
        totalPages={totalPages}
        onPageClick={handlePageChange}
        pagesData={templateData?.pages}
      />

      <div className="form-content">{renderPageContent()}</div>

      <div className="form-actions">
        <PageNavigation
          currentPage={currentPage}
          totalPages={totalPages}
          onPrevious={() => handlePageChange(currentPage - 1)}
          onNext={() => handlePageChange(currentPage + 1)}
          onSubmit={handleSubmit}
        />
      </div>

      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>처리 중입니다...</p>
        </div>
      )}
    </div>
  );
};

export default NewCase;
